import React from "react"

export interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Additional styles to be applied to the container. */
  styleOverrides?: string
}

const defaultStyles = "flex"

/**
 * Container component.
 *
 * This component renders a div element with optional ARIA roles and labels.
 *
 * @component
 * @param {ContainerProps} props The properties for the component.
 * @returns {React.ReactNode} The rendered container element.
 */
const Container = React.forwardRef<HTMLDivElement, ContainerProps>(
  function Container({ children, styleOverrides, ...props }, ref) {
    const className = styleOverrides
      ? `${defaultStyles} ${styleOverrides}`
      : defaultStyles
    return (
      <div ref={ref} className={className} {...props}>
        {children}
      </div>
    )
  },
)

Container.displayName = "Container"

export default Container
